import { render } from "./ScheduleAddEditModal.vue?vue&type=template&id=0bf8181e&scoped=true&ts=true"
import script from "./ScheduleAddEditModal.vue?vue&type=script&lang=ts"
export * from "./ScheduleAddEditModal.vue?vue&type=script&lang=ts"

import "./ScheduleAddEditModal.vue?vue&type=style&index=0&id=0bf8181e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf8181e"]])

export default __exports__